import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { SubscriptionService } from "../../services/subscription.service";
import { ISubscription } from "../../models/Subscription";

export const useGetAllSubscriptionsQuery = (searchValue: string | null) => {
  return useQuery<ISubscription[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_ALL_SUBSCRIPTIONS, searchValue],
    queryFn: () => SubscriptionService.getAllSubscriptions(searchValue).then((res) => res.data),
  });
};
